/**
 * chat v1 — the managed AWS-serverless chat backend
 * (contract: avengents-homepage/docs/CHAT-SERVICE.md).
 *
 * This is a THIRD transport lane, deliberately separate from the two cookie-based ones
 * (the same-origin BFF `bffJson`, and the edge relay `api.*`): a Cognito **JWT bearer**
 * over HTTPS plus a real API-Gateway **WebSocket**. Nothing here shares the cookie or the
 * edge-relay envelope.
 *
 * The endpoints are browser-facing by design — a Cognito client id and hosted-UI domain
 * are public values, not secrets — so they default to the deployed stack here and can be
 * overridden per environment via `VITE_CHATV1_*`. avg-main owns these; update on redeploy.
 */
const env = import.meta.env as Record<string, string | undefined>

/** Production's HTTP API — the default, so a build that names no stage is prod's. */
const PROD_HTTP = 'https://ab71sv4gpf.execute-api.us-west-2.amazonaws.com'

export const CHATV1 = {
  /** HTTP API base (Cognito-JWT authorizer): /devices, /ws-ticket, /conversations, … */
  http: env.VITE_CHATV1_HTTP ?? PROD_HTTP,
  /** WebSocket API base; connect as `${ws}?ticket=<id>`. */
  ws: env.VITE_CHATV1_WS ?? 'wss://fmg52fqgk0.execute-api.us-west-2.amazonaws.com/prod',
  /** Cognito hosted-UI domain (for the Google→Cognito authorize redirect — real login). */
  authDomain:
    env.VITE_CHATV1_AUTH_DOMAIN ??
    'https://avg-chat-216989114735.auth.us-west-2.amazoncognito.com',
  /** Cognito app client id (public). */
  clientId: env.VITE_CHATV1_CLIENT_ID ?? 'pf764evham56111hnhqca4prc',
  /** Cognito user-pool id (public). */
  userPoolId: env.VITE_CHATV1_USER_POOL_ID ?? 'us-west-2_Tq8620MIF',
} as const

/** A build whose chat is production's (no stage named): what a game not yet tested there is hidden from (games/flag.ts). */
export const CHATV1_IS_PROD = CHATV1.http === PROD_HTTP
